module.exports = __webpack_public_path__ + "assets/excavator.svg?4c040a9fc879fcdebe1f3ca1eaba9c3d";